<template>
  <!-- 全局 iconfont 图标使用 -->

  <i @click="trigger" :style="[isStyle?styleObject:'',{fontSize:size+'px'}]" class="fa" :class="[iconNameCard]">
    <span class="fa" :class="[iconName,!isHover?'iconItemDefault':'iconItem']" aria-hidden="true"></span>
  </i>
</template>

<script>
export default {
  props: {
    name: 'fontIcon',
    // icon 尺寸大小
    size: {
      type: [String, Number],
      default: 16
    },
    // icon名称
    iconName: {
      type: [String],
      default: ''
    },
    // icon针对卡片名称
    iconNameCard: {
      type: [String],
      default: ''
    },
    // icon颜色
    iconColor: {
      type: [String],
      default: '#0046B9'
    },
    // icon 鼠标移动颜色
    iconColorHover: {
      type: [String],
      default: '#fff'
    },
    isHover: {
      type: [Boolean],
      default: false
    },
    // 去除行内样式控制
    isStyle: {
      type: [Boolean],
      default: true,
    }
  },
  computed: {
    styleObject() {
      return {
        "--font-color-hover": this.iconColorHover,//鼠标滑动 字体颜色
        "--font-color": this.iconColor,//鼠标滑动 字体颜色
      }
    },
  },
  methods: {
    trigger(e) {
      this.$emit('click', e)
    }
  }
};
</script>

<style lang='scss' scoped>
$color-hover: var(--font-color-hover);
$color-font: var(--font-color);
.iconItemDefault {
  color: $color-font;
}
.iconItem {
  color: $color-font;
  &:hover {
    color: $color-hover;
  }
}
</style>